const AUTHENTICATED_VIEWS = ['dashboard', 'negotiationBoticario', 'negotiationEudora', 'paymentBoticario', 'paymentEudora', 'finishBoticario', 'finishEudora', 'agreementBillDetail'];

const VIEW_STEP_MAP = {
    dashboard: 1,
    negotiationBoticario: 2,
    negotiationEudora: 2,
    paymentBoticario: 3,
    paymentEudora: 3,
    finishBoticario: 4,
    finishEudora: 4,
    agreementBillDetail: 0,
};

export default {
    currentView: state => state.currentView,

    isAuthenticatedView: state => AUTHENTICATED_VIEWS.includes(state.currentView),

    currentStep: state => VIEW_STEP_MAP[state.currentView] || 1,

    currentBrand(state) {
        if (state.currentView === 'agreementBillDetail' && state.agreementBillBrand) {
            return state.agreementBillBrand;
        }
        if (state.currentView === 'negotiationBoticario') return 'boticario';
        if (state.currentView === 'negotiationEudora') return 'eudora';
        if (state.currentView === 'paymentBoticario') return 'boticario';
        if (state.currentView === 'paymentEudora') return 'eudora';
        if (state.currentView === 'finishBoticario') return 'boticario';
        if (state.currentView === 'finishEudora') return 'eudora';
        // Sem dívidas boticário (só Eudora) → cor Eudora no dashboard
        if (state.hasNoBoticarioData && !state.hasNoEudoraData) return 'eudora';
        return 'default';
    },

    titulosEudoraNegociacao(state) {
        const offer = state.offersEudora && state.offersEudora[0];
        if (!offer || offer.installments == null || offer.installments === '') return 'Eudora';
        const raw = offer.installments;
        return Array.isArray(raw) ? raw.join(' | ') : String(raw);
    },

    isAcceptCardEnabled: () => (offer) => {
        if (!offer) return false;
        const v = offer.acceptCard ?? offer.accept_card;
        return v === true || String(v).toLowerCase() === 'true' || v === 1;
    },

    /** Dívida Boticário com ofertas para negociar (não é só preventivo / acordo já fechado na API). */
    hasActiveDebtsBoticario(state) {
        const debts = state.debtsBoticario;
        if (!Array.isArray(debts) || debts.length === 0) return false;
        return debts.some((d) => {
            const offers = d.offersBoticario;
            return Array.isArray(offers) && offers.length > 0;
        });
    },

    hasActiveDebtsEudora(state) {
        const debts = state.debtsEudora;
        return debts != null
            && debts.length > 0
            && state.offersEudora != null
            && state.offersEudora.length > 0;
    },

    /** Esferas 1–4 no topo: no dashboard, só quando há fluxo de negociação (ofertas em aberto). */
    showNegotiationStepperOnDashboard(state, getters) {
        return getters.hasActiveDebtsBoticario || getters.hasActiveDebtsEudora;
    },
}
